import { render, staticRenderFns } from "./historyStudentList.vue?vue&type=template&id=20480f50&"
import script from "./historyStudentList.vue?vue&type=script&lang=js&"
export * from "./historyStudentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports